/**
 * Shared color constants for the map layer (Leaflet `divIcon` HTML strings and
 * `pathOptions`), where Tailwind utility classes can't reach. This is the single
 * source of truth for raw color values used in JS — keep it in sync with the
 * Tailwind `brand`/`vipps` tokens in tailwind.config.js and the CSS theme
 * variables in index.html. Prefer Tailwind classes in JSX; use these only for
 * Leaflet/Canvas/inline-style code paths that need a literal string.
 */

// Brand (emerald) — mirrors tailwind `brand` / `brand.dark`
export const BRAND = '#10b981';
export const BRAND_DARK = '#059669';

// Vipps — mirrors tailwind `vipps`
export const VIPPS = '#ff5b24';

/**
 * Semantic spot/route status colors. Used for marker fills, path strokes and
 * status dots. The Tailwind equivalents (for JSX) are noted alongside.
 */
export const STATUS = {
  legal: '#10b981',     // emerald-500  — allowed / verified
  forbidden: '#ef4444', // red-500      — not allowed
  caution: '#f59e0b',   // amber-500    — check signs / uncertain
  public: '#3b82f6',    // blue-500     — public / official source
  premium: '#6366f1',   // indigo-500   — premium / algorithmic
  highlight: '#ec4899', // pink-500     — selected / emphasis
} as const;

export type SpotStatusColor = keyof typeof STATUS;

// Neutral marker chrome
export const MARKER = {
  white: '#ffffff',
  ink: '#1c1917',       // stone-900 text on light marker
  shadow: 'rgba(0,0,0,0.3)',
} as const;
